import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon/Icon.js';
import styles from './SidePanelInfoBox.module.scss.js';

var SidePanelInfoBox = function SidePanelInfoBox(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    attentionText = _ref.attentionText,
    className = _ref.className,
    infoBoxActionIcon = _ref.infoBoxActionIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.box, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    icon: icon,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("h2", {
    className: styles.header
  }, title), infoBoxActionIcon || null), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, text), /*#__PURE__*/React.createElement("p", {
    className: "error"
  }, attentionText));
};
SidePanelInfoBox.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  attentionText: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  infoBoxActionIcon: PropTypes.node
};
SidePanelInfoBox.defaultProps = {
  icon: '',
  title: '',
  text: '',
  attentionText: '',
  className: '',
  infoBoxActionIcon: null
};

export { SidePanelInfoBox as default };
